<template>
    <div>
      <v-row>
        <v-col cols="6">
          <div class="pa-4 rounded fill-height zoezi-card-default square-box">
            <h3 class="text-center font-weight-light" >{{ $translate('Number of workouts') }}</h3>
            <h3 class="text-center">{{ allWorkouts }}</h3>
            <p class="text-center text-caption mb-0 mt-2">{{$translate('This month')}}: {{ workoutsThisMonth }}</p>
          </div>
        </v-col>
        <v-col cols="6">
          <div class="pa-4 rounded fill-height zoezi-card-default square-box">
            <h3 class="text-center font-weight-light" >{{ $translate('Next workout') }}</h3>
            <h3 class="text-center shorten-text">{{ nextWorkout ? Date.newFull(nextWorkout.startTime).ddSlashmm() + ' ' + Date.newFull(nextWorkout.startTime).hhmm() : $translate('No workout booked') }}</h3>
            <h3 class="text-center shorten-text">{{ nextWorkout ? nextWorkout.workoutType.name : '' }}</h3>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <ChartJsDoughnut :chart-data="data" :chart-options="options" :plugins="[keepFourEntriesPlugin]" class="pa-4 rounded zoezi-card-default" />
        </v-col>
      </v-row>
    </div>
</template>

<script>
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Doughnut as ChartJsDoughnut } from 'vue-chartjs/legacy'
ChartJS.register(ArcElement, Tooltip, Legend)

export default {
  name: "zoezi-my-workout-stats",

  zoezi: {
    title: "My group exercise statistics",
    icon: 'mdi-chart-line-variant'
  },

  components: {
    ChartJsDoughnut
  },

  computed: {
    data() {
        if (!this.gdata) {
            return {};
        }

        let labels = Object.keys(this.gdata.workouttypes)
        let values = Object.values(this.gdata.workouttypes);
        // Sorting numbers and labels
        const indexedNumbers = values.map((value, index) => ({ value: value.count, index }));
        indexedNumbers.sort((a, b) => b.value - a.value);
        const sortedLabels = indexedNumbers.map(({ index }) => labels[index]);
        const sortedNumbers = indexedNumbers.map(({ value }) => value);
      
        let datasets = [{
            backgroundColor: values.map(x => x.color),
            borderColor: values.map(x => x.color),
            data: sortedNumbers
        }]

        return {
            labels: sortedLabels, datasets
        }
    },
    options() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            title: {
                display: true,
                text: this.$translate('Group workout'),
                font: {
                  size: 24
                }
            },
            legend: {
              display: true,
              position: 'right',
              align: 'right',
              labels: {
                usePointStyle: true,
                pointStyle: 'circle',
                padding: 12,
                font: {
                  size: 14,
                  weight: 700
                }
              },
            },
        },
      }
    }
  },

  data: () => ({
    gdata: null,
    nextWorkout: null,
    allWorkouts: 0,
    workoutsThisMonth: 0,
    primaryColor: '#00000000',

    keepFourEntriesPlugin: {
      beforeInit: function (chart) {
        var config = chart.config;
        var data = config.data;
        var dataset = data.datasets[0];
        var originalData = dataset.data; // Store the original data points
        var labels = data.labels;

        const maxCount = 4;
        let otherValue = 0;
        let newLabels = [];
        originalData.forEach((seg, index) => {
          if (index < maxCount) {
            newLabels.push(labels[index]);
          }
          else {
            otherValue += seg;
          }
        });

        if (otherValue > 0) {
          newLabels.push(window.$translate('Others'));
        }

        chart.config.data.labels = newLabels;
        chart.config.data.datasets[0].data.splice(4, dataset.data.length - 4);
        chart.config.data.datasets[0].data.push(otherValue);
      },
    }
  }),

  mounted() {
    this.primaryColor = this.$root.colorToHex('primary');

    let fromDate = new Date(0);
    let toDate = Date.today();
    this.$api.get('/api/memberapi/stats', {fromDate: fromDate.yyyymmdd(), toDate: toDate.yyyymmdd(), types: 'workouttypes,bookings' }).then(data => {
        if (!data.bookings) {
          data.bookings = {};
        }
        this.gdata = data;
        Object.keys(data.bookings).forEach(key => {
          this.allWorkouts += data.bookings[key];
          let itemDate = Date.newFull(key);
          if (itemDate.getMonth() == new Date().getMonth()) {
            if (itemDate.getFullYear() == new Date().getFullYear()) {
              this.workoutsThisMonth += data.bookings[key];
            }
          }          
        });
    });
    this.$api.get('/api/memberapi/bookings/get', {fromDate: (new Date().yyyymmdd() + new Date().hhmm())}).then(data => {
      if (data?.workouts?.length > 0) {
        this.nextWorkout = data.workouts[0];
      }
    })
  }
}
</script>
